import React, { FC } from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import moment, { Moment } from 'moment';

import ContentFilter from '../../../components_/Content/ContentFilter';
import FormRow from '../../../components_/Form/FormRow';
import FormCol from '../../../components_/Form/FormCol';
import AntSelect from '../../../components_/Fields/AntSelect';
import InputNumber from '../../../components_/Fields/AntInputNumber';

import checkFilter from '../../../utils/checkFilter';
import { IProps as IWorkingTimeProps } from '../WorkingTime';
import { IId } from '../../../models/types';
import AntRangePicker from '../../../components_/Fields/AntRangePicker';

interface IProps {
  data: IWorkingTimeProps['data'];
  filter: any;
  isLoadingGetList: boolean;
  isLoadingExportList: boolean;
  list: IWorkingTimeProps['list']['data'];
  onChange: any;
  onClickApply: () => void;
  onClickExport: () => void;
  onClickReset: () => void;
  filterType: string;
}

const Filter: FC<IProps> = ({
  data,
  filter,
  isLoadingGetList,
  isLoadingExportList,
  list,
  onChange,
  onClickApply,
  onClickExport,
  onClickReset,
  filterType
}) => {
  const { employees, timeTable } = data;
  const { listOfEmployees, timeTableId, from, to, timeDiffSeconds } = filter;

  const { isApply, isDownload, isShowReset } = checkFilter(filter, ['from'], list);

  const employeeOptions = employees.map((employee: { id: IId; fullName: string }) => ({
    label: employee.fullName,
    value: employee.id
  }));

  const timeTableOptions = timeTable.map(
    (employee: { id: string; startTime: string; name: string; timetableDuration: number }) => ({
      label: employee.name,
      value: employee.id
    })
  );

  const nowEnd = moment().endOf('day');

  return (
    <ContentFilter>
      <FormRow alignItems="flex-end">
        <FormCol xs={2}>
          <AntSelect
            name="listOfEmployees"
            label="Сотрудник (необязательно)"
            placeholder="Выберите значение"
            options={employeeOptions}
            optionFilterProp="label"
            mode="multiple"
            allowClear
            value={listOfEmployees}
            onChange={onChange}
          />
        </FormCol>
        {filterType === 'Table' && (
          <FormCol xs={2}>
            <AntSelect
              name="timeTableId"
              label="Смена (необязательно)"
              placeholder="Выберите значение"
              options={timeTableOptions}
              optionFilterProp="label"
              allowClear
              value={timeTableId}
              onChange={onChange}
            />
          </FormCol>
        )}
        <FormCol xs={3}>
          <AntRangePicker
            fromName={'from'}
            toName={'to'}
            from={from}
            to={to}
            format={'DD.MM.YYYY'}
            label={'Дата'}
            onChange={onChange}
            disabledDate={(current: Moment) => current && current.isAfter(nowEnd)}
          />
        </FormCol>
        <FormCol xs={1}>
          <InputNumber
            name="timeDiffSeconds"
            label="Детальность графика"
            suffix="сек"
            placeholder="15"
            min={5}
            // antd InputNumber has no controlHeight rule for the default size, so it
            // renders shorter than the Select/RangePicker beside it — pin to controlHeight.
            style={{ width: '100%', height: 32 }}
            value={timeDiffSeconds}
            defaultValue={15}
            onChange={onChange}
          />
        </FormCol>
        <FormCol style={{ display: 'flex', justifyContent: 'flex-end' }} xs={4}>
          <Button
            style={{ marginRight: '0.5rem', marginBottom: '0.25rem' }}
            type="primary"
            variant="filled"
            disabled={isApply}
            loading={isLoadingGetList}
            onClick={onClickApply}
          >
            Применить
          </Button>
          {isShowReset && (
            <Button
              onClick={onClickReset}
              variant="filled"
              color="default"
              style={{ marginRight: '0.5rem', marginBottom: '0.25rem' }}
            >
              Сбросить
            </Button>
          )}
          <Button
            style={{ marginBottom: '0.25rem' }}
            disabled={isDownload}
            color="default"
            variant="filled"
            // loading={isLoadingExportList}
            onClick={onClickExport}
            icon={<DownloadOutlined />}
          >
            Скачать
          </Button>
        </FormCol>
      </FormRow>
    </ContentFilter>
  );
};

export default Filter;
